var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('img',{attrs:{"src":"/img/logo.png"}}),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.titleOrDefault))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }